import { FormFieldErrorType } from "@zenith/types";

export enum TeamManagementFields {
  FIRST_NAME = "firstName",
  LAST_NAME = "lastName",
  PHONE_NUMBER = "phoneNumber",
  EMAIL = "email",
}

export type TeamManagementForm = {
  [TeamManagementFields.FIRST_NAME]: string;
  [TeamManagementFields.LAST_NAME]: string;
  [TeamManagementFields.PHONE_NUMBER]: string;
  [TeamManagementFields.EMAIL]: string;
};

export type TeamManagementFormValidation = {
  [key in keyof TeamManagementForm]?: FormFieldErrorType;
};

export type TeamManagementFormType = {
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
};
